// extract customer reference id from global scope that is set by personalised app
// TODO the idea is to provide this data to the SDK from extension. For better security it will be added to the store
const getCustomerReferenceId = () => {
  const { gelatoData: ppExtensionData = {} as { customerReferenceId: string | undefined } } =
    window as typeof window & { gelatoData?: { customerReferenceId?: string } };
  return ppExtensionData.customerReferenceId;
};

export default getCustomerReferenceId;
